<template>
  <div>
    <div
      style="display: flex; align-items: center"
      v-for="(answer, answerIndex) in question.answers"
      :key="answerIndex"
    >
      <div
        :style="
          isStudentAnswerShown(answer.key) && submission.isStudentWork
            ? 'display: inline-flex;min-width:30px;min-height:30px;padding:5px;align-items:center;justify-content:center;border:1px solid black;border-radius:50%;'
            : 'display: inline-flex;min-width:30px;min-height:30px;padding:5px;align-items:center;justify-content:center;'
        "
      >
        {{ answer.label }}.
      </div>
      <div v-html="answer.value || ''" style="margin-left: 4px"></div>

      <div
        v-if="!submission.isQuestionPaper && !submission.isStudentWork && isAnswerShown"
        style="display: inline-flex"
        class="ml-2"
      >
        <!-- Kiểm tra nếu đây là phương án học sinh đã chọn -->
        <div v-if="isStudentAnswerShown(answer.key)">
          <!-- Tải kết quả (Hiện Đúng/Sai - Xanh/Đỏ) -->
          <span
            :style="{color: isCorrect ? '#4bca81' : '#d4504c', fontWeight: 'bold', fontSize: '14px'}"
            v-html="isCorrect ? '&#10003;' : '&#x2715;'"
          />

          <!--Tải bài làm HS (Chỉ hiện dấu tích đen để nhận diện câu đã chọn) -->
          <!-- <span v-else style="color: #000; font-weight: bold; font-size: 14px" v-html="'&#10003;'"></span> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import get from 'lodash-es/get'
import {mapGetters} from 'vuex'

export default {
  props: {
    question: Object,
  },
  computed: {
    ...mapGetters({
      submission: 'pdfRender/getSubmission',
    }),
    isAnswerShown() {
      return get(this.submission, `answers.${this.question.id}`)
    },
    isCorrect() {
      const studentAnswer = get(this.submission, `answers.${this.question.id}`)
      return get(studentAnswer, 'isCorrect', false)
    },
  },
  methods: {
    isStudentAnswerShown(ansKey = '') {
      const studentAnswer = get(this.submission, `answers.${this.question.id}`)
      return get(studentAnswer, 'answerId', '') === ansKey
    },
  },
}
</script>